<div class="help-dialog" [class]="'help-dialog mode-' + data.modeInfo.id">
  <button
    class="close-button"
    type="button"
    (click)="dialogRef.close()"
    [attr.aria-label]="'EDITOR.TOP_PANEL.HELP.CLOSE' | translate">
    x
  </button>

  <div class="hero">
    <div class="hero-icon">
      <mat-icon [svgIcon]="data.modeInfo.icon"></mat-icon>
    </div>

    <div class="hero-copy">
      <span class="eyebrow">{{ 'EDITOR.TOP_PANEL.HELP.BADGE' | translate }}</span>
      <h2>{{ data.modeInfo.titleKey | translate }}</h2>
      <p class="tagline">{{ data.modeInfo.helpKey + '.TAGLINE' | translate }}</p>
    </div>
  </div>

  <p class="description">{{ data.modeInfo.helpKey + '.DESCRIPTION' | translate }}</p>

  <section class="details">
    <h3>{{ 'EDITOR.TOP_PANEL.HELP.SECTION_TITLE' | translate }}</h3>
    <div class="chip-list">
      @for (chipKey of data.modeInfo.chipKeys; track chipKey) {
      <span class="chip">{{ chipKey | translate }}</span>
      }
    </div>
  </section>

  <div class="footer-note">
    <span class="footer-dot"></span>
    <p>{{ 'EDITOR.TOP_PANEL.HELP.FOOTER' | translate }}</p>
  </div>

  <div class="actions">
    <button type="button" mat-flat-button class="close-action" (click)="dialogRef.close()">
      {{ 'EDITOR.TOP_PANEL.HELP.CLOSE' | translate }}
    </button>
  </div>
</div>
